import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useApp } from "../context/AppContext";
import { STATS, translations } from "../i18n";
import Reveal from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "do_public_settings";
const FALLBACK = STATS.map((s) => ({ num: s.num, label_ar: translations[s.key].ar, label_en: translations[s.key].en }));

export default function StatsStrip() {
  const { lang, t } = useApp();
  const Arrow = lang === "ar" ? ArrowLeft : ArrowRight;
  const [stats, setStats] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem(KEY))?.home_stats || FALLBACK; } catch { return FALLBACK; }
  });

  useEffect(() => {
    axios.get(`${API}/settings/public`).then((r) => {
      sessionStorage.setItem(KEY, JSON.stringify(r.data));
      if (Array.isArray(r.data.home_stats) && r.data.home_stats.length) setStats(r.data.home_stats);
    }).catch(() => {});
  }, []);

  return (
    <section className="stats-strip" data-testid="stats-strip">
      <div className="stats-inner">
        <Reveal><h2 className="stats-title">{t("stats.title")}</h2></Reveal>
        <div className="stats-grid">
          {stats.map((s, i) => (
            <Reveal key={i} delay={i * 130}>
              {s.link ? (
                <Link to={s.link} className="stat-item stat-link" data-testid={`stat-item-${i}`}>
                  <span className="stat-num">{s.num}</span>
                  <span className="stat-label">{lang === "ar" ? s.label_ar : s.label_en} <Arrow size={13} /></span>
                </Link>
              ) : (
                <div className="stat-item" data-testid={`stat-item-${i}`}>
                  <span className="stat-num">{s.num}</span>
                  <span className="stat-label">{lang === "ar" ? s.label_ar : s.label_en}</span>
                </div>
              )}
            </Reveal>
          ))}
        </div>
        <Reveal delay={280}>
          <Link to="/map" className="stats-cta" data-testid="stats-map-link">{t("stats.cta")}<Arrow size={16} /></Link>
        </Reveal>
      </div>
    </section>
  );
}
